
import '../src/global.css';

import { useScrollToTop } from '../src/hooks/use-scroll-to-top';

import Router from '../src/routes/sections';
import ThemeProvider from '../src/theme';
import OrderNotificationListener from './sections/oder/OrderNotificationListener';

export default function App() {
  useScrollToTop();

  return (
    <ThemeProvider>
      <OrderNotificationListener /> 
      <Router />
    </ThemeProvider>
  );
}
